import { render, staticRenderFns } from "./ContEdit.vue?vue&type=template&id=590616c8&scoped=true&"
import script from "./ContEdit.vue?vue&type=script&lang=js&"
export * from "./ContEdit.vue?vue&type=script&lang=js&"
import style0 from "./ContEdit.vue?vue&type=style&index=0&id=590616c8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590616c8",
  null
  
)

export default component.exports